import * as api from 'utils/api';

interface GetMegaMenuLink {
  text: string;
  link: string;
  subItems: Array<GetMegaMenuLink & { subItems?: GetMegaMenuLink[] }>;
}

export interface GetMegaMenuItem {
  value: string;
  text: string;
  links: GetMegaMenuLink[];
}

interface IGetMegaMenuResponse {
  items: Record<
    string,
    {
      value: string;
      text: string;
      links: GetMegaMenuLink[];
    }
  >;
  itemOrder: string[];
}

export interface MegaMenuItem {
  id: string;
  href: string;
  text: string;
  subItems?: MegaMenuItem[];
}

export default class WebcoreService {
  /**
   * api request adapter object
   */
  private adapter: api.Adapter;

  constructor() {
    this.adapter = new api.Adapter({
      baseURL: 'https://cs30dxxhfd.execute-api.ap-southeast-2.amazonaws.com/exp',
      responseType: 'json',
      headers: {
        timeout: 60 * 10 * 1000,
        'content-type': 'application/json',
        accept: 'application/json'
      }
    });
  }

  async getMegaMenuItems(): Promise<MegaMenuItem[]> {
    const { data } = await this.adapter.getValue<IGetMegaMenuResponse>('/v1/megamenu');

    const items: Record<string, typeof data.items[0]> = Object.values(data.items).reduce(
      (result, currentValue) => ({ ...result, [currentValue.text]: currentValue }),
      {}
    );

    const convertLinksToSubItems = (links: GetMegaMenuLink[]) => {
      return links.map(link => ({
        id: link.text,
        text: link.text,
        href: link.link,
        subItems: link.subItems ? convertLinksToSubItems(link.subItems) : undefined
      }));
    };

    return data.itemOrder.map(text => {
      const menuItem = items[text];

      return {
        id: menuItem.value,
        text: menuItem.text,
        href: '',
        subItems: convertLinksToSubItems(menuItem.links)
      };
    });
  }
}
